import { render, staticRenderFns } from "./AdminJeux.vue?vue&type=template&id=dfafaf06&scoped=true"
import script from "./AdminJeux.vue?vue&type=script&lang=js"
export * from "./AdminJeux.vue?vue&type=script&lang=js"
import style0 from "./AdminJeux.vue?vue&type=style&index=0&id=dfafaf06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfafaf06",
  null
  
)

export default component.exports